import React, { useState } from 'react';
import { kebabCase } from 'lodash';
import Icon from '../icon/Icon';
import styled from 'styled-components';

interface CollapsibleProps {
  label: string;
}

export const Collapsible: React.ComponentType<React.PropsWithChildren<CollapsibleProps>> = ({ children, label }) => {
  const [open, setOpen] = useState(false);
  const idName = kebabCase(label);

  return (
    <>
      <StyledButton
        type="button"
        aria-expanded={open}
        aria-controls={`${idName}-content`}
        id={`${idName}-trigger`}
        onClick={() => setOpen((current) => !current)}
      >
        <Icon type={open ? 'caret-down' : 'caret-up'} />
        {label}
      </StyledButton>
      <Content
        id={`${idName}-content`}
        role="region"
        aria-labelledby={`${idName}-trigger`}
        aria-hidden={!open}
        open={open}
      >
        {children}
      </Content>
    </>
  );
};

const StyledButton = styled.button`
  font-size: 12px;
  display: inline-flex;
  gap: 5px;
`;

const Content = styled.div<{ open: boolean }>`
  transition: all 0.3s ease-in-out;
  max-height: ${({ open }) => (open ? '100vh' : 0)};
  overflow: hidden;
`;
